import { Attachment } from '../models/attachment.model';
import { Repository } from './repository';

import { Service } from '../entity';
import { CentralApis } from '../interfaces/internal';
import { Inject, Injectable } from '@angular/core';
import { ENV, IEnvironment } from 'env/config';
import { DataService } from '../http/dataService';

@Service({
  api: 'attachment',
  model: Attachment,
})
@Injectable({ providedIn: 'root' })
export class AttachmentService extends Repository<Attachment> {
  constructor(@Inject(ENV) env: IEnvironment, dataService: DataService) {
    super({
      client: dataService,
      url: (env.api.backend.central.endpoint as CentralApis).activity,
    });
  }

  createFromDTO(item): Attachment {
    return item;
  }
}
